import { useLotteryServer } from 'middle-domain';
import lotteryWinner from '../components/lottery-winner.vue';

export default {
  data() {
    return {
      keyword: '',
      winLotteryUserList: [], // 抽奖的结果
      inited: false,
      isLoading: false, // 抽奖列表是否在请求中
      lotteryList: [],
      total: 0,
      forceEnd: 0,
      lotteryTime: 0,
      countDownLotteryTime: 0,
      isSearch: false,
      pageInfo: {
        limit: 10,
        pageNum: 1
      },
      lotteryInterval: 0,
      countDownLotteryInterval: 0
    };
  },
  components: {
    lotteryWinner
  },
  computed: {
    // 暂未创建列表
    noData() {
      return this.keyword === '' && this.total === 0 && !this.isSearch;
    },
    // 是否正在直播
    isLiving() {
      return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
    },
    userId() {
      return this.$domainStore.state.roomBaseServer.watchInitData.join_info.third_party_user_id;
    }
  },
  beforeCreate() {
    this.lotteryServer = useLotteryServer({
      mode: 'live'
    });
  },
  beforeDestroy() {
    if (this.lotteryInterval) {
      window.clearInterval(this.lotteryInterval);
    }
    if (this.countDownLotteryInterval) {
      window.clearInterval(this.countDownLotteryInterval);
    }
    this.removeMsgEvent();
  },
  created() {
    this.initMsgEvent();
  },
  methods: {
    lotteryTypeName(row) {
      if (row.lottery_type == 1) {
        return this.$t('host.k_583008');
      } else if (row.lottery_type == 2) {
        return this.$t('host.k_583009');
      } else if (row.lottery_type == 3) {
        return this.$t('host.k_583010');
      } else if (row.lottery_type == 8) {
        return this.$t('host.k_583011');
      } else if (row.lottery_type == 9) {
        return this.$t('host.k_583012');
      } else if (row.lottery_type == 20) {
        return this.$t('host.k_583013');
      } else if (row.lottery_type == 21) {
        return this.$t('host.k_583014');
      } else {
        return row.lottery_type_name;
      }
    },

    initMsgEvent() {
      //监听结束抽奖
      this.lotteryServer.$on(
        this.lotteryServer.Events.LOTTERY_RESULT_NOTICE,
        this.callBackResultNotice
      );
      this.lotteryServer.$on(this.lotteryServer.Events.LOTTERY_PUSH, this.callBackBeginNotice);
    },
    removeMsgEvent() {
      this.lotteryServer.$off(
        this.lotteryServer.Events.LOTTERY_RESULT_NOTICE,
        this.callBackResultNotice
      );
      this.lotteryServer.$off(this.lotteryServer.Events.LOTTERY_PUSH, this.callBackBeginNotice);
    },
    // 抽奖结束(需要同步助理/嘉宾)
    callBackResultNotice(msg) {
      console.log('抽奖结束');

      if (this.lotteryInterval) {
        window.clearInterval(this.lotteryInterval);
      }
      if (this.countDownLotteryInterval) {
        window.clearInterval(this.countDownLotteryInterval);
      }
      const lotteryId = msg.data.lottery_id;
      if (msg.data.lottery_method == 1) {
        this.lotteryList.forEach(item => {
          if (item.lottery_id == lotteryId) {
            console.log('抽奖结束', item.lottery_status);
            if (item.lottery_status != 1) {
              //倒计时抽奖 自动打开查看中奖名单
              // 查看中奖名单
              setTimeout(() => {
                this.goLookWinning(lotteryId);
              }, 200);
            }
            item.lottery_status = 1;
          }
        });
      }

      if (this.isMallMode) {
        this.handleSearch();
      } else {
        this.getLotteryList();
      }
    },
    // 开始抽奖 (需要同步助理/嘉宾)
    callBackBeginNotice(msg) {
      //如果是自己推的，就不走消息
      if (this.userId == msg.data.lottery_publisher_id) return;
      const lotteryId = msg.data.lottery_id;
      this.lotteryList.forEach(item => {
        if (item.lottery_id === lotteryId) {
          item.lottery_status = 0;
          if (item.lottery_method == 1) {
            //倒计时开奖
            this.countDownLotteryTime = item.countdown_time;
            this.calculateCountDownLotteryTime();
            // } else {
          }
          // 倒计时也是用 计时器，是为了计算结束按钮必须是5s的限制
          this.lotteryTime = 0;
          this.calculateLotteryTime();
          // }
        }
      });
    },
    // 搜索
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.total = 0;
      this.lotteryList = [];
      this.inited = false;
      this.getLotteryList();
    },
    // 列表
    getLotteryList() {
      if (this.isLoading) return false;
      if (this.isMallMode && this.inited && this.lotteryList.length >= this.total) return false;
      this.isSearch = this.keyword ? true : false;
      const params = {
        limit: this.pageInfo.limit,
        title: this.keyword || undefined
      };
      if (this.isMallMode) {
        // 卡片模式
        params.pos = this.lotteryList.length;
      } else {
        this.lotteryList = [];
        params.pos = parseInt((this.pageInfo.pageNum - 1) * this.pageInfo.limit);
      }

      this.isLoading = true;
      this.lotteryServer
        .getLotteryLiveList(params)
        .then(res => {
          if (res.code === 200 && res.data) {
            this.inited = true;
            this.total = res.data.total;
            let list = res.data.list;
            this.lotteryList.push(...list);
            this.lotteryList.forEach(item => {
              if (item.lottery_status == 0) {
                if (item.lottery_method == 1) {
                  //倒计时开奖
                  this.countDownLotteryTime = item.countdown_time;
                  this.calculateCountDownLotteryTime();
                  // } else {
                }
                // 倒计时也是用 计时器，是为了计算结束按钮必须是5s的限制
                this.lotteryTime = item.spent_time;
                this.calculateLotteryTime();
                // }
              }
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 复制
    copeLottery(id) {
      this.lotteryServer
        .lotteryLiveCope(id)
        .then(res => {
          if (res.code === 200 && res.data) {
            if (this.isMallMode) {
              this.handleSearch();
            } else {
              this.getLotteryList();
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(e => {
          this.$message.error(e.msg);
        });
    },
    // 删除
    deleteLottery(item) {
      if (item.lottery_status == 0) return;
      let lotteryId = item.lottery_id;
      this.$vhConfirm(this.$t('host.k_583001'), this.$t('host.k_583002'), {
        confirmButtonText: this.$t('host.k_583003'),
        cancelButtonText: this.$t('host.k_583004'),
        closeOnClickModal: false,
        roundButton: true
      }).then(() => {
        this.lotteryServer
          .lotteryLiveDelete(lotteryId)
          .then(res => {
            if (res.code === 200) {
              if (this.isMallMode) {
                this.handleSearch();
              } else {
                this.getLotteryList();
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(e => {
            this.$message.error(e.msg);
          });
      });
    },
    // 推送抽奖
    publishLottery(id) {
      if (!this.isLiving) {
        this.$message.warning(this.$t('host.k_583005'));
        return;
      }
      this.lotteryServer.lotteryLivePublish(id).then(res => {
        if (res.code === 200) {
          this.lotteryList.forEach(item => {
            if (item.lottery_id === id) {
              item.lottery_status = 0;
              if (item.lottery_method == 1) {
                //倒计时开奖
                this.countDownLotteryTime = item.countdown_time;
                this.calculateCountDownLotteryTime();
                // } else {
              }
              // 倒计时也是用 计时器，是为了计算结束按钮必须是5s的限制
              this.lotteryTime = 0;
              this.calculateLotteryTime();
              // }
            }
          });
          //推送抽奖成功数据埋点
          window.VhallDataAgent.track('interact_publish_response', {
            button_type: 'lottery_click',
            button_biz_id: id,
            is_success: 1
          });
        } else {
          this.$message.error(this.$t(res.msg));
          //推送抽奖失败数据埋点
          window.VhallDataAgent.track('interact_publish_response', {
            button_type: 'lottery_click',
            button_biz_id: id,
            is_success: 0
          });
        }
      });
    },
    // 结束抽奖
    endLottery(id) {
      this.lotteryServer
        .lotteryLiveClose(id, this.forceEnd)
        .then(res => {
          if (res.code === 200) {
            if (this.lotteryInterval) {
              window.clearInterval(this.lotteryInterval);
            }
            if (this.countDownLotteryInterval) {
              window.clearInterval(this.countDownLotteryInterval);
            }
            this.forceEnd = 0;
            this.lotteryList.forEach(item => {
              if (item.lottery_id === id) {
                item.lottery_status = 1;
              }
            });
            // 查看中奖名单
            setTimeout(() => {
              this.goLookWinning(id);
            }, 200);
          } else if (res.code === 516734) {
            this.$vhConfirm(
              this.$t('host.k_583006'),
              this.$t('host.k_583002'),

              {
                confirmButtonText: this.$t('host.k_583007'),
                cancelButtonText: this.$t('host.k_583004'),
                closeOnClickModal: false,
                roundButton: true
              }
            )
              .then(() => {
                this.forceEnd = 1;
                this.endLottery(id);
              })
              .catch(() => {
                this.forceEnd = 0;
              });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 查看中奖名单
    goLookWinning(id) {
      this.$refs.lotteryWin.openWinList(id);
    },
    getWinnerList(id) {
      let params = {
        limit: 10,
        pos: 0,
        need_desensitization: 0,
        lottery_id: id
      };
      this.lotteryServer
        .getLiveWinnerList(params)
        .then(res => {
          this.lotteryList.forEach(item => {
            if (item.lottery_id === id) {
              item.winners_num = res.data?.total || 0;
            }
          });
        })
        .then(() => {});
    },
    // 开播时间计时器
    calculateLotteryTime() {
      if (this.lotteryInterval) {
        window.clearInterval(this.lotteryInterval);
      }
      this.lotteryInterval = window.setInterval(() => {
        this.lotteryTime++;
      }, 1000);
    },
    // 开播时间计时器 - 倒计时
    calculateCountDownLotteryTime() {
      if (this.countDownLotteryInterval) {
        window.clearInterval(this.countDownLotteryInterval);
      }
      this.countDownLotteryInterval = window.setInterval(() => {
        if (this.countDownLotteryTime > 0) {
          this.countDownLotteryTime--;
        }
      }, 1000);
    },
    formatDuration(info) {
      // console.log(info);
      let temp = 0;
      if (info.lottery_method == 1) {
        //倒计时抽奖
        temp = this.countDownLotteryTime * 1000;
      } else {
        temp = this.lotteryTime * 1000;
      }

      const hours = dayjs.duration(temp).hours();
      const minutes = dayjs.duration(temp).minutes();
      const seconds = dayjs.duration(temp).seconds();
      /* prettier-ignore */
      return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
    }
  }
};
